import React from 'react'
import {renderComponent} from './Layout'

export default class Gelaende extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    click(e) {
        if (e.target.tagName != "LI") return;

        const flaeche = e.target.getAttribute('data-flaeche');
        if (!flaeche) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }

        this.refs.root.className="active-" + flaeche;
    }

    mouseenter(e) {
        if (e.target.tagName != "LI") return;

        const flaeche = e.target.getAttribute('data-flaeche');
        if (!flaeche) {
            return;
        }
        this.refs.root.className="active-" + flaeche;
    }

    mouseleave(e) {
        if (e.target.tagName != "LI") return;

        const flaeche = e.target.getAttribute('data-flaeche');
        if (!flaeche) {
            return;
        }
        this.refs.root.className = "";        
    }

    componentDidMount() {
        const gelaendeList = this.refs.root.getElementsByClassName('gelaende-list')[0];
        gelaendeList.addEventListener('click', (e) => this.click(e), true);
        gelaendeList.addEventListener('mouseenter', (e) => this.mouseenter(e), true);
        gelaendeList.addEventListener('mouseleave', (e) => this.mouseleave(e), true);

        const nodes = gelaendeList.getElementsByTagName("LI");
        for (var i = nodes.length - 1; i >= 0; i--) {
            const flaeche = nodes[i].getAttribute('data-flaeche');
            const content = nodes[i].getElementsByTagName("P")[0];
            const nummer = this.refs.root.getElementsByClassName("nummer-" + flaeche)[0];
            if (nummer) {
                content.style.left =  nummer.offsetLeft + "px";
                content.style.top = nummer.offsetTop + "px";
            }
        }
    }

    render() {
        return <div ref="root" dangerouslySetInnerHTML={{__html: this.props.html}} />
    }
}



// WEBPACK FOOTER //
// ./src/components/Gelaende.jsx